import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnDestroy,
  Optional,
  Inject
} from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ConfigStateService } from "../../../../../app/config/config-state.service";
import { TaxReturnService } from "../../../../../../swaggerServices";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { DropdownListOption } from "../../../search-dropdown/search-dropdown.component";
import { TaxReturnStatus } from "../../../../../app/tax-returns/tax-return/model/status";
import { Tenant } from "../../../../types/tenant.enum";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";

@Component({
    selector: "bulk-status-update",
    templateUrl: "./bulk-status-update.component.html",
    styleUrls: ["./bulk-status-update.component.scss"],
    standalone: false
})
export class BulkStatusUpdateComponent implements OnInit, OnDestroy {
  @Input() selectedTaxReturns;
  @Input() taxReturnAlias: string;
  @Output() completed = new EventEmitter();

  showBulkStatusUpdate: boolean = false;
  statusOptions = [];
  statusUpdateResponse: any;
  bulkActionState: "OPENED" | "LOADING" | "COMPLETED" = null;
  showStatusUpdateModal = false;
  selectedStatusName = "";
  selectedStatusOption = null;
  inlineMessage = "";
  newStatus = "";
  errorMessage = "";
  statusUpdateForm: UntypedFormGroup = new UntypedFormGroup({});
  private unsubscribe: Subject<void> = new Subject();
  placeholder = "Select ...";
  constructor(
    private taxReturnService: TaxReturnService,
    public configStateService: ConfigStateService,
    @Optional() private dialogRef?: MatDialogRef<BulkStatusUpdateComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) data?: Partial<BulkStatusUpdateComponent>
  ) {
    Object.assign(this, data);
  }

  get selectedTaxReturnIds() {
    return this.selectedTaxReturns
      ? Object.keys(this.selectedTaxReturns).map(n => Number(n))
      : [];
  }

  ngOnInit() {
    this.statusOptions = this.makeTaxReturnStatusOptions();
    this.bulkActionState = "OPENED";
    this.showStatusUpdateModal = true;
    this.statusUpdateForm.addControl("status", new UntypedFormControl(""));
    this.selectedStatusOption = null;
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  onStatusSelection(event) {
    this.selectedStatusOption = event.id;
  }
  getFormControl() {
    return this.statusUpdateForm && this.statusUpdateForm.get("status")
      ? this.statusUpdateForm.get("status")
      : null;
  }
  updateStatus() {
    if (this.selectedStatusOption) {
      this.bulkActionState = "LOADING";
      this.taxReturnService
        .bulkStatusUpdate({
          statusId: this.selectedStatusOption,
          taxReturnIds: this.selectedTaxReturnIds
        })
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(
          resp => {
            this.statusUpdateResponse = resp;
            this.bulkActionState = "COMPLETED";
          },
          error => {
            this.errorMessage = "Something went wrong, please try again later.";
            this.bulkActionState = "OPENED";
            return;
          }
        );
    } else {
      this.errorMessage = "Please select a valid status name.";
    }
  }

  onClose(result: boolean = false) {
    if (this.dialogRef) {
      this.dialogRef.close(result);
    }
    this.showStatusUpdateModal = false;
    this.completed.emit();
  }

  makeTaxReturnStatusOptions(): Array<DropdownListOption> {
    if (this.configStateService.tenant === Tenant.ESS) {
      return [
        { id: 1, value: "WAITING_FOR_PREP", name: "Ready for Preparation" },
        { id: 2, value: "IN_PREPARE", name: "Preparation" },
        { id: 3, value: "AWAITING_FIRST_REIVEW", name: "Ready for Review" },
        { id: 4, value: "IN_FIRST_REIVEW", name: "In Review" },
        {
          id: 5,
          value: "AWATING_CLIENT_APPROVAL",
          name: "Awaiting Client Approval"
        },
        { id: 6, value: "LODGED", name: "Lodged" }
      ];
    } else {
      return [
        {
          id: -1,
          name: "All",
          value: "All",
          order: -1
        }
      ].concat(
        TaxReturnStatus.asList(this.configStateService, false).map(
          (opt, i) => ({
            id: opt.id,
            name: opt.name,
            value: opt.name,
            order: i
          })
        )
      );
    }
  }
}
